import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { setSelection } from './EditorStatusSlice';

type WordCountTarget = 'document' | 'selection';

type WordCountSliceState = {
  wordsQuantity: { [key in WordCountTarget]: number | null };
  summary: { [key in WordCountTarget]: Editor.Data.Proofing.ProofingData['summary'] | null };
  partials: Editor.Data.Proofing.ProofingData['partials'];
};

const SLICE_NAME = 'WORD_COUNT';
const initialState: WordCountSliceState = {
  wordsQuantity: {
    document: null,
    selection: null,
  },
  summary: {
    document: null,
    selection: null,
  },
  partials: {},
};

// #region Slice
const wordCountSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setWordsQuantity: (
      state,
      action: PayloadAction<{
        target: WordCountTarget;
        summary: Editor.Data.Proofing.ProofingData['summary'];
        partials: Editor.Data.Proofing.ProofingData['partials'];
      }>,
    ) => {
      const { target, summary, partials } = action.payload;
      state.wordsQuantity[target] = summary.WORDS;
      state.summary[target] = summary;
      state.partials = partials;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setSelection, (state, action) => {
      if (action.payload.COLLAPSED) {
        state.wordsQuantity.selection = null;
      }
    });
  },
});

export default wordCountSlice.reducer;
// #endregion

// #region Actions
export const { setWordsQuantity } = wordCountSlice.actions;
// #endregion
